import { getImageMetadataFromBlob } from './get-image-metadata';
import { getGifMetadataFromBlob, isGifMimeType } from './gif-metadata';
import type { MediaMetadata } from './media-metadata-types';

export type { MediaMetadata, MediaNativeSize } from './media-metadata-types';

export function getMediaMetadataFromBlob(input: {
  blob: Blob;
  mimeType?: string | null;
}): Promise<MediaMetadata | null> {
  const mimeType = input.mimeType ?? input.blob.type;

  if (isGifMimeType(mimeType)) {
    return getGifMetadataFromBlob({ blob: input.blob, mimeType });
  }

  return getImageMetadataFromBlob({ blob: input.blob, mimeType });
}
